/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import InfiniteScroll from 'react-infinite-scroll-component';
import Lot from "./lot";
import { dataService } from "../../../../../services/dataService";
import BidsShimmer from "../../bids/bidsShimmer";
import NoSearchScreen from "../../../../../CommonComponent/ListingScreens/NoSearchScreen";
import TableHeader from "../../../../../CommonComponent/ListingScreens/TableHeader";

export default function LotTable(props){
    const { 
        lots,
        handleDelete,
        loader,
        setDeleteLotModal,
        deleteLotModal,
        fetchHandler,
        handleSort, 
        currentSortColumn,
        searchParams,
        searchValue,
        loadLots,
        lotInfo, lotDetailsFromSocket,
        isSearched,
        auctionData,
        isSocket, loading
    } = props;
    const [items, setItems] = useState([]);
    const [limit, setLimit] = useState(10); // Track the current page
    const dragItem = useRef();
    const dragOverItem = useRef();
    const { id }=useParams();
    const Navigate = useNavigate();

    const handleDragStart = (position) => {
        dragItem.current = position;
    };
    const handleDragEnter = (position) => {
        dragOverItem.current = position;
    };
    const handleReorderLots = async(reorder_lot_number, reorder_position)=>{
        const response = await dataService.reorderLot({
            "auction_id": lots[0].auction_id,
            "reorder_lot_number": reorder_lot_number,
            "reorder_position": reorder_position,
        });
        return response;
    }
    const handleDrop = async () => {
        const [currentItem, overItem] = [dragItem.current, dragOverItem.current]
        if (currentItem !== null && overItem !== null) {
            const copyListItems = [...items];
            const dragItemContent = copyListItems.splice(currentItem, 1);
            copyListItems.splice(overItem, 0, dragItemContent[0]);
            setItems(copyListItems);
            dragItem.current = null;
            dragOverItem.current = null;
            await(handleReorderLots(lots[currentItem].lot_number, lots[overItem].lot_number))
            fetchMoreData()
        }
    };

    /**
     * The function fetches more data and updates the state with the new items.
     */
    const fetchMoreData = async () => {
        const nexPage = limit + 10;
        await fetchHandler(limit);
        setLimit(nexPage);
    };

    useEffect(() => {
        fetchMoreData();
    },[]);

    useEffect(() => {
        if(lots){
            setItems(lots);
        }
    }, [lots])

    const columns = [
        { label: "Lot number", sortKey: "lot_number", testId: "sort-lot-number", minWidth: "140px" },
        { label: "", minWidth: "120px" },
        { label: "Title", sortKey: "title1", testId: "sort-title", minWidth: "170px" },
        { label: "Starting bid", sortKey: "starting_price", testId: "starting_price", minWidth: "140px" },
        { label: "Current bid", sortKey: "current_bid", testId: "current_bid", minWidth: "130px" },
        { label: "Top bidder", sortKey: "top_bidder", testId: "top_bidder", minWidth: "170px" },
        { label: "Paddle no.", sortKey: "paddle_number", testId: "paddle_number", minWidth: "130px" },
        { label: "", minWidth: "60px" },
    ];

    return(
        <div className="md:pb-[70px] pb-[100px] pt-2 overflow-auto mt-4 customScrollbar">
            <div className="z-10 border-[#DEDEDE] border rounded-lg xl:w-full w-fit" 
                style={{transform: "rotateX(180deg)"}}>
                <InfiniteScroll
                    dataLength={items.length}
                    next={fetchMoreData}
                    hasMore={true}
                    loader={<h4></h4>}
                    className="lots"
                    scrollableTarget="customScroll"
                >
                    <table aria-label="Outside Table" className="w-full overflow-auto table-auto" 
                        style={{transform: "rotateX(-180deg)"}}>
                        <TableHeader currentSortColumn={currentSortColumn} handleSort={handleSort} columns={columns} />
                        <tbody>
                            {(!loadLots && items.length > 0 && !loading ) && (
                                <Lot
                                    lots={items}
                                    auctionData={auctionData}
                                    loader={loader}
                                    handleDelete={handleDelete}
                                    deleteLotModal={deleteLotModal}
                                    setDeleteLotModal={setDeleteLotModal}
                                    onDragStart={handleDragStart}
                                    onDragEnter={handleDragEnter}
                                    onDragEnd={handleDrop}
                                    lotDetailsFromSocket={lotDetailsFromSocket}
                                    isSocket={isSocket}
                                />
                            )}
                            {(!loading && !loadLots && searchValue !== '' && searchParams.get('search')!==null && items.length==0) &&
                                <NoSearchScreen searchValue={searchValue} cols={7} />}
                            {(!isSearched && !loadLots && !loading && items.length==0 && searchParams.get('search')=== null) && 
                                <tr className="">
                                    <td colSpan="7" className="sm:text-center text-start sm:pl-0 
                                        xs:pl-[200px] pl-[100px]">
                                        <div className="h-[180px] mt-[100px]">
                                            <p
                                                className="text-[18px] font-medium  leading-normal 
                                                        text-[#34343 mb-4"
                                            >
                                                Start adding lots to your auction
                                            </p>
                                            <button 
                                                type="button" 
                                                data-testid='create-lot-button'
                                                disabled={(
                                                    auctionData.template_name==='Single Lot' && 
                                                        lotInfo.total_records_found===1
                                                )}
                                                onClick={() => 
                                                    Navigate(`/auctions/${id}/${auctionData.auction_id}/lots/create`, {state: {auction: auctionData}})
                                                }
                                                className="px-[31px] mt-2 py-[12px] bg-[#282828] sm:mx-0 
                                                        mx-3 text-[#FFFFFF] leading-normal font-medium text-[14px] 
                                                        rounded-[6px] disabled:bg-[#D4D4D8] hover:bg-[#3F3F45]
                                                        disabled:text-[hsl(240,4%,65%)]"
                                            >
                                                Create lot
                                            </button>
                                        </div>
                                    </td>
                                </tr>}
                            
                            {(loadLots || loading) &&
                            <BidsShimmer/>}
                        </tbody>
                       
                    </table>
                </InfiniteScroll>
            </div>
           
        </div>
    );
}